<template lang="pug">
  .sidecart-wrapper
    transition(name="fade")
      .sidecart__overlay(v-if="sidecartOpen" @click="close")
    transition(name="off-canvas-right")
      .sidecart(v-if="sidecartOpen" v-touch:swipe.right="close")
        .sidecart__header
          .sidecart__header-icon
            icon-button(
              icon="cart"
              width="26px"
              height="21px"
              label="Open Cart"
              @click="$store.dispatch('cart/openSidecart')"
            )
            span.sidecart__header-icon__quantity {{ totalItems }}
          h2.sidecart__title Shopping Cart
          icon-button.sidecart__close(icon="close" size="18px" label="Close side cart" @click="close")
        .sidecart__free-shipping {{ freeShippingBarContent }}
        .sidecart__container
          transition(name="fade", mode="out-in")
            .sidecart__contents-wrapper(v-if="totalItems > 0" key="content")
              .sidecart__contents
                sidecart-line-item(
                  v-for="(item, index) in items"
                  :item="item"
                  :line="index + 1"
                  :key="item.id"
                )
                <div :data-handle="getLatestItem"></div>

                <div v-if="showUpsell == true">
                  <div class="upsell_wrap " v-if="itemAdded === false">
                    <h2 class="upsell_title">{{ upsellSectionTitle }}</h2>
                    <div class="sidecart__upsell">
                      <img :src="upsellProduct.product.image.src" :alt="upsellProduct.product.title" class="sidecart__upsell_img">
                      <div class="sidecart__upsell_product_info">
                        <h3>{{ upsellProduct.product.title }}</h3>
                        <p>${{ upsellPrice }}</p>
                        <div class="upsell_option" v-if="upsellProduct.product.options[0] && upsellProduct.product.options[0].name != 'Title'">
                          <label>{{ upsellProduct.product.options[0].name  }}</label>
                          <select @change="setVariant()" v-model="option_1">
                            <option v-for="val in upsellProduct.product.options[0].values" :value="val">{{val}}</option>
                          </select>
                        </div>
                        <div class="upsell_option" v-if="upsellProduct.product.options[1]">
                          <label>{{ upsellProduct.product.options[1].name }}</label>
                          <select @change="setVariant()" v-model="option_2">
                            <option v-for="val in upsellProduct.product.options[1].values" :value="val">{{val}}</option>
                          </select>
                        </div>
                        <button v-on:click="addUpsell" class="button button--primary button--full">Add to Cart</button>
                      </div>
                    
                    </div>
                    
                    
                  </div>
                </div>
                
                

              .sidecart__footer
                .sidecart__extra
                .option-section
                  .input.input--checkbox
                      <input type="checkbox" v-model="noteCheckbox" id="physical-note" name="send-gift-info" value="Yes" onchange="valueChanged()" @change="noteUpdate">
                      .input--checkbox__indicator
                      <label for="physical-note"> {{ noteTitle }}
                        
                        span(v-if="notePrice") ({{ notePrice | money  }})
                      </label>
                      .tooltip-container
                        <img class="tooltip-icon" src="https://cdn.shopify.com/s/files/1/0779/9179/files/info-icon.svg?v=1605625479" />
                        span.tooltip {{ noteInfo }}
                .gift-note-box
                  <textarea v-on:blur="handleNote" name="gift-note" v-model="cartNote" rows="4" cols="50"></textarea>
                 
                p.sidecart__subtotal
                  span Subtotal
                  span {{ totalPrice | money }}
                checkout-button.sidecart__checkout-cta.button--full(:full="true" label="Checkout")
            .sidecart__empty(
              v-else
            )
              p.sidecart__empty-message {{ emptyText }}
              link-button(
                :label="emptyButtonText"
                :href="emptyButtonLink"
              )
</template>

<script>
  import { mapState } from 'vuex';

  import CheckoutButton from 'scripts/components/buttons/CheckoutButton.vue';
  import IconButton from 'scripts/components/buttons/IconButton.vue';
  import LinkButton from 'scripts/components/buttons/LinkButton.vue';
  import SidecartLineItem from 'scripts/components/cart/SidecartLineItem.vue';

  export default {
    name: 'Sidecart',
    data () {
      return {
        cartNote: '',
        noteCheckbox: false,
        noteCount: 0,
        itemAdded: false,
        isSubscription: false,
        showUpsell: false,
        option_1: '',
        option_2: '',
        variant_id: '',
        latestItem: '',
        higherTotalTrigger: 5000,
        handleUnder50: '',
        handleOver50: '',
        upsellSectionTitle: 'You might also like',
        upsellHandle: '',
        upsellProduct: {},
        upsellVariantData: [],
        upsellTitle: '',
        upsellImgSrc: '',
        upsellCompareAtPrice: '',
        upsellPrice: '',
        upsellOpt1Name: '',
        upsellOpt2Name: '',
        upsellOpt1: [],
        upsellOpt2: [],
      }
    },
    components: {
      CheckoutButton,
      LinkButton,
      IconButton,
      SidecartLineItem,
    },
    props: {
      emptyText: String,
      emptyButtonLink: String,
      emptyButtonText: String,
      customerId: String,
      customerEmail: String,
      permanentDomain: String,
      freeShippingThreshold: Number,
      freeShippingText: String,
      noteTitle: String,
      noteInfo: String,
      noteVariant: String,
      notePrice: String,
    },
    computed: {
      ...mapState({
        allProducts: state => state.products.all,
        sidecartOpen: state => state.cart.sidecartOpen,
        items: state => state.cart.checkout.items,
        itemsSubtotal: state => state.cart.checkout.items_subtotal_price,
        totalDiscount: state => state.cart.checkout.total_discount,
        totalPrice: state => state.cart.checkout.total_price,
        totalItems: state => state.cart.checkout.item_count,
      }),
      freeShippingBarContent () {
        const totalInDollars = this.totalPrice / 100.0;
        const amountRemaing = (this.freeShippingThreshold - totalInDollars).toFixed(2);
        return amountRemaing <= 0 ? this.freeShippingText : `Add $${amountRemaing} for Free Shipping`;
      },
      getLatestItem() { 
        console.log('this.items', this.items)
        
        /* const list = this.items;
        console.log('list:', list)
        // if we want the highest price item:
        const highPrice = list.reduce((acc, item) => acc = acc > item.price ? acc : item.price, 0);
        const highPriceItem = list.find( ({price}) => price == highPrice)
        this.latestItem = highPriceItem;
        return highPriceItem; */
        // check for subscription
        const checkProp = this.items[0].properties;
        console.log('checkProp', checkProp)
        if (checkProp !== null) {
          const checkProp3 = this.items[0].properties.hasOwnProperty('shipping_interval_frequency')
          if ( checkProp3 ) {
            console.log('checkProp3', checkProp3)
            this.isSubscription = true;
            console.log('this.isSubscription: ', this.isSubscription)
          }
        } else {
          console.log('it was null')
        }
        
        
        let latestItem = this.items[0].handle;
        // in case we need to strip a string for subscription products - 
        // can they have metafields? (that won't get overwritten on re-sync)
        // latestItem = latestItem.replace('-1', '');
        this.latestItem = latestItem;
        // console.log('latestItem: ', latestItem);

        // in theme.liquid and product.liquid we print out divs with these values from the cart items, 
        // that's how we get our hands on the metafield value
        console.log('latestItem: ', latestItem);
        console.log('this.totalPrice', this.totalPrice);

        let upsellHandleDiv = document.querySelector('[data-cartitem="' + this.latestItem + '"]');
        console.log('upsellHandleDiv', upsellHandleDiv);
        let upsellHandleDiv50 = document.querySelector('[data-cartitem50="' + this.latestItem + '"]');
        console.log('upsellHandleDiv50', upsellHandleDiv50);
        //higherTotalTrigger
        
        if ( upsellHandleDiv50 !== null ) {
          console.log('upsellHandleDiv50', upsellHandleDiv50)
          this.handleOver50 = upsellHandleDiv50.dataset.cartupsellhandle50;
          let sectionTitle = upsellHandleDiv50.dataset.cartupselltitle;
          console.log('sectionTitle', sectionTitle);
          if ( sectionTitle ) {
            this.upsellSectionTitle = sectionTitle;
          }
        }

        if ( upsellHandleDiv !== null ) {
          this.handleUnder50= upsellHandleDiv.dataset.cartupsellhandle;
          // use this value for over 50 if that is ''
          if (this.handleOver50 === '') {
            this.handleOver50 = upsellHandleDiv.dataset.cartupsellhandle;
          }
          console.log('upsellHandleDiv.dataset.highertotalamount', upsellHandleDiv.dataset.highertotalamount)
          if ( upsellHandleDiv.dataset.higherTotalAmount != '' ) {
            let customAmount = upsellHandleDiv.dataset.highertotalamount;
            if (customAmount.length > 0) {
              customAmount = customAmount.replace('.', '');
              customAmount = parseInt(customAmount, 10);
              console.log('customAmount3: ', customAmount)
              this.higherTotalTrigger = customAmount;
            }
            
          }
          let sectionTitle = upsellHandleDiv.dataset.cartupselltitle;
          console.log('sectionTitle', sectionTitle);
          if ( sectionTitle ) {
            this.upsellSectionTitle = sectionTitle;
          }
        }

        if ( this.totalPrice > this.higherTotalTrigger ) {
          this.upsellHandle = this.handleOver50;
        } else {
          this.upsellHandle = this.handleUnder50;
        }


        
        console.log('this.upsellHandle: ', this.upsellHandle);

        if ( this.upsellHandle !== '') {
          var create_URL = "https://joshua-tree-coffee-company.myshopify.com/products/"+ this.upsellHandle + ".json";
          fetch(create_URL).then(response => {
              // The API call was successful!
              if (response.ok) {
                  return response.json();
              } else {
                  return Promise.reject(response);
              }
          }).then( data => {
              //console.log('here is the data: ', data);
              console.log('this.upsellProduct: ', Object.keys(this.upsellProduct).length);
              this.upsellProduct = data;
              console.log('this.upsellProduct: ', Object.keys(this.upsellProduct).length);
              console.log('this.upsellProduct: ', this.upsellProduct);
              this.upsellVariantData = data.product.variants;
              console.log('this.upsellVariantData: ', this.upsellVariantData);
              this.upsellPrice = data.product.variants[0].price;
              this.upsellCompareAtPrice = data.product.variants[0].compare_at_price;
              this.option_1 = data.product.variants[0].option1;
              this.option_2 = data.product.variants[0].option2;
              this.variant_id = data.product.variants[0].id;

          }).catch(function (err) {
              //fetchFail(err)
              console.log(err);
          });
        }

      


        return latestItem;
        //getVariantData();
      },
    },
    watch: {
        upsellProduct: {
            handler: function(val, oldVal) {
                this.showUpsell = true;
            },
            deep: true
        }
    }, 
    mounted () {
      this.initStorefrontData();
    },
    methods: {
      initStorefrontData () {
        // set up customer data is there is a login
        if (this.customerId && this.customerEmail) {
          this.$store.dispatch('storefront/initCustomer', {
            id: this.customerId,
            email: this.customerEmail,
          });
        }

        // set up the permanent domain
        if (this.permanentDomain) {
          this.$store.dispatch('storefront/initPermanentDomain', this.permanentDomain);
        }
      },
      close () {
        this.$store.dispatch('cart/closeSidecart');
      },

      setVariant() {
        const newVarTitle = this.option_1 + ' / ' + this.option_2;
        const newVar = this.upsellProduct.product.variants.find(el => el.title === newVarTitle)
        console.log('newVarTitle: ', newVarTitle, ' newVar: ', newVar);
        this.variant_id = newVar.id;
        this.upsellPrice = newVar.price;
        this.upsellCompareAtPrice = newVar.compare_at_price;
        console.log('this.upsellPrice: ', this.upsellPrice, ' this.variant_id: ', this.variant_id);
      },

      addUpsell() {
        function get_cookie(name){ return( document.cookie.match('(^|; )'+name+'=([^;]*)')||0 )[2] }
        
        var data = {
          "id": this.variant_id,
          "quantity": 1
        }

        console.log('updated data: ', data)

        // this.whatEver is not available in the jQuery function below, so we set the values here:
        // because 'this' has a different context in that function
        // var isGift = this.giftWrap;
        var that = this.$store;
        var that2 = this;

        function updateTheCart() {
          that.dispatch('cart/init');
          that2.itemAdded = true;
          console.log('that2.itemAdded', that2.itemAdded);
        }

        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          dataType: 'json',
          success: function () {
            console.log('success!');
            updateTheCart();

            //console.log(data.properties);
            do {
              var token=get_cookie('cart');
            }
            while(token == undefined);
            
          }
        });
      },


      addNoteTextToCart() {
        
        var data = {
          "note": this.noteVariant
        }

        console.log('updated data: ', data)

        jQuery.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: data,
          dataType: 'json',
          success: function () {
            console.log('success for note!');
          }
        });
      },

      addNoteToCart() {

        /* if ( this.date === '' ) {
          let today =   new Date();
          this.date = today;
          this.dateFormat = moment(today).format('MMMM Do YYYY');//
        } */

        function get_cookie(name){ return( document.cookie.match('(^|; )'+name+'=([^;]*)')||0 )[2] }
        
        var data = {
          "id": this.noteVariant,
          "quantity": 1
        }
        
        if (this.cartNote !== '') {
          console.log('noted: ', this.cartNote);
        }

        console.log('updated data: ', data)

        // this.whatEver is not available in the jQuery function below, so we set the values here:
        // because 'this' has a different context in that function
        // var isGift = this.giftWrap;
        var theCartNote = this.cartNote;
        var that = this.$store;

        function updateTheCart() {
          that.dispatch('cart/init');
        }

        jQuery.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          dataType: 'json',
          success: function () {
            console.log('success!');
            updateTheCart();
            if (theCartNote) {
              //console.log('we have a note.')
              addNoteTextToCart();
            }
            /* if (isGift) {
              //console.log('gift wrap!');
              jQuery.post('/cart/update.js', "attributes[Gift wrap]=Yes");
            } */

            //console.log(data.properties);
            do {
              var token=get_cookie('cart');
            }
            while(token == undefined);

            /* var myshopify_domain='{{ shop.permanent_domain }}'
            try { var ga_linker = ga.getAll()[0].get('linkerParam') } catch(err) { var ga_linker ='' }
            var customer_param = '{% if customer %}customer_id={{customer.id}}&customer_email={{customer.email}}{% endif %}'
            var checkout_url= "https://checkout.rechargeapps.com/r/checkout?myshopify_domain=joshua-tree-coffee-company.myshopify.com&cart_token="+token+"&"+ga_linker;
            // var checkout_url= '/cart';
            console.log(checkout_url);
            setTimeout(function() {
              window.location = checkout_url
            }, 500) */
            
          }
        });
      },

      removeNoteFromCart(checkNote) {
        function clearNote() {
          var data = {
            "note": ''
          }

          console.log('updated3 data: ', data)

          jQuery.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: data,
            dataType: 'json',
            success: function () {
              console.log('success!');
            }
          });
        }

        clearNote();
        this.cartNote = '';

        if (checkNote) {
          let minus = checkNote.querySelector('.sidecart__line-item__quantity button');
          //let qty = checkNote.querySelector('.sidecart__line-item__quantity__label').innerText;
          //qty = parseInt(qty, 10);
          if (minus) {
            minus.click();
          }
        }
        
      },
    
      noteUpdate() {
        var that = this.$store;
        function updateTheCart() {
          that.dispatch('cart/init');
        }
        let checkNote = document.querySelector('[data-variantid="' + this.noteVariant + '"]');
        if (checkNote) {
          this.noteCount = 1;
        }
        //console.log('checkNote: ', checkNote)
        //console.log('note checkbox: ', this.noteCheckbox);
        //only do something if there is a noteVariant
        if (this.noteVariant) {
          console.log('update - we have noteVariant', this.noteVariant)
          if ( this.noteCheckbox && this.noteCount == 0 ) {
          console.log('update - we have noteCount', this.noteCount)
            // we don't want to add the note to the cart multiple times, so we'll keep track
            this.noteCount = 1;
            this.addNoteToCart();
          } if ( !this.noteCheckbox ) {
            // remove product
            if (this.noteCount == 1) {
              let checkNote = document.querySelector('[data-variantid="' + this.noteVariant + '"]');
              if (checkNote) {
                this.noteCount = 1;
              }

              var variantId = this.noteVariant;
              console.log('variantId: ', variantId)
              this.removeNoteFromCart(checkNote);
            }
            this.noteCount = 0;
          }
        } else if ( !this.noteCheckbox ) {
          this.removeNoteFromCart();
        }

        
      },
      handleNote() {
        console.log('note: ', this.cartNote);
        console.log('checkbox: ', this.noteCheckbox)
        var theCartNote = this.cartNote;
        if (this.noteCheckbox) {
          this.addNoteTextToCart();
        } else {
          this.removeNoteFromCart();
        }
        
      }
    },
  };
</script>

<style scoped lang="scss">
  .sidecart {
    display: flex;
    flex-direction: column;
    background-color: $bg--main;
    width: calc(100% - #{$grid-gutter});

    @include tablet-up {
      max-width: 480px;
    }

    &, &__overlay {
      position: fixed;
      right: 0;
      top: 0;
      height: 100%;
    }

    &__overlay {
      width: 100%;
      background-color: $color-transparent-black;
    }

    &__header {
      padding: 11px 18px;
      display: flex;
      flex-shrink: 0;
      justify-content: space-between;
      align-items: center;
      background-color: $color-pink;
      color: $color-indigo;

      &::v-deep .icon {
        &, &:hover {
          fill: $color-dark-grey;
        }
      }
    }

    &__footer {
      padding: $grid-gutter;
      flex-shrink: 0;

      .option-section {
        font-size: .875rem;
      }
      .input--checkbox label {
        font-size: .875rem;
      }
    }

    &__promo {
      background-color: $bg--light;
      padding: 15px $grid-gutter;

      &__copy {
        margin: 0;
        padding: 0;
        text-align: center;
        font-size: rem(13);
        line-height: 1.5;
        font-weight: bold;
      }
    }

    &__container {
      display: flex;
      flex-grow: 1;
      min-height: 0; // override auto to prevent growing too tall
      background-color: $color-white;
    }

    &__contents {
      flex-grow: 1;
      padding: 0 $grid-gutter;
      overflow-y: auto;
      overflow-x: hidden;

      &-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex-grow: 1;
        width: 100%;
      }
    }

    &__title {
      flex-grow: 1;
      margin: 0;
      padding-left: 16px;
      font-size: rem(20);
      line-height: 1.25;
      color: $color-indigo;
    }

    &__subtotal {
      margin: 2em 0 0;
      display: flex;
      justify-content: space-between;
      font-size: rem(16);
      line-height: 1.28;
      color: $text--mid;
      text-align: center;
      font-family: $font-gibson;
    }

    &__checkout-cta {
      margin-top: $grid-gutter;
    }

    &__empty {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-align: center;
      width: 100%;
      padding: 0 $grid-gutter;

      &__message {
        font-size: rem(18);
        line-height: 1.28;
      }

      &__image,
      &__message {
        margin: 0 0 $grid-gutter;
      }
    }
  }

  .sidecart__empty-message {
    margin-top: 0;
  }

  .sidecart__free-shipping {
    padding: 15px;
    text-align: center;
    background-color: $color-off-white;
    font-family: $font-gibson;
  }

  .tooltip-icon {
		max-width: 15px;
		width: 100%;
		margin-bottom: -2px;
	}

	.final-title {
		margin-top: 10px;
		h4 {
			margin-top: 0;
			margin-bottom: 20px;
			font-size: 20px;
		}
	}

	//clean up later
	.tooltip-container {
		cursor: pointer;
		position: relative;
		display: inline-block;
	}

	.tooltip {
		opacity: 0;
		z-index: 99;
		color: #fff;
		width: 190px;
		display: block;
		font-size: 11px;
		font-weight: normal;
		padding: 5px 10px;
		border-radius: 3px;
		text-align: center;
		background: rgba(51, 51, 51, 0.95);
		border: 1px solid rgba(34, 34, 34, 0.95);
		box-shadow: 0 0 3px rgba(0, 0, 0, 0.5);
		transition: all 0.2s ease-in-out;
		transform: scale(0);
		position: absolute;
		right: -92px;
		top: calc(100% + 12px);
    @media screen and (max-width: 600px) {
        width: 76vw;
      }
	}

	.tooltip:before,
	.tooltip:after {
		content: '';
		border-left: 10px solid transparent;
		border-right: 10px solid transparent;
		border-bottom: 10px solid rgba(51, 51, 51, 0.95);
		position: absolute;
		top: -10px;
		left: 43%;
		@media only screen and (max-width: 600px) {
			top: calc(50% - 10px);
			left: inherit;
			right: -10px;
			border-left: 10px solid rgba(51, 51, 51, 0.95);
			border-top: 10px solid transparent;
			border-bottom: 10px solid transparent;
			border-right: none;
		}
	}

	.tooltip-container:hover .tooltip,
	a:hover .tooltip {
		opacity: 1;
		transform: scale(1);
		@media only screen and (max-width: 600px) {
			top: 50%;
			right: 3em;
			transform: translateY(-50%) scale(1);
		}
	}
  
  .upsell_wrap {
    margin-top: .5rem;
    /* border: #CFCECD solid 1px; */

    .upsell_title {
      margin: 0;
      padding: .55rem .5rem .45rem;
      /* background-color: #CFCECD; */
      background-color: #F6DADF;
      color: #0A2B6F;
      /* color: #000; */
      text-align: center;
      font-size: 1.125rem;
      line-height: 1;
    }
  }
.sidecart__upsell {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    padding: 0 .5rem 1rem;
    border: #F6DADF solid 1px;
    border-top: none;
    
    h3 {
      font-size: 1rem;
      margin-bottom: 0;
    }
    p {
      font-size: .9375rem;
      margin-top: 0;
    }
    .upsell_option {
      display: flex;
      align-items: center;
      @media screen and (max-width: 600px) {
        flex-direction: column;
        align-items: flex-start;
      }
    }
    label {
      display: inline-block;
      width: 3.5em;
      font-size: .75rem;
    }
    select {
      padding: .5rem .5rem;
      border: #0A2B6F solid 1px;
      border-radius: 0;
      flex-grow: 1;
      font-size: .9375rem;
      @media screen and (max-width: 600px) {
        width: 100%;
        max-width: 100%;
      }
    }
    .upsell_option {
      margin-bottom: .7rem;
    }
    .button {
      padding: 10px 0 11px;
      @media screen and (max-width: 600px) {
        min-width: initial;
      }
    }
}
.sidecart__upsell_img {
  width: 120px;
}
.sidecart__upsell_product_info {
  width: calc(100% - 125px);
}
</style>
